import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    wishLists: getWishListsDataView(state, state.pages.myLists.getWishListsParameter),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface MyListsCountStyles {
    listCountText: TypographyProps;
}

export const listsCountStyles: MyListsCountStyles = {
    listCountText: {
        variant: "h5",
        as: "p",
        css: css`
            font-weight: normal;
        `,
    },
};

const styles = listsCountStyles;

const MyListsCount: React.FC<Props> = ({ wishLists }) => {
    const listCount = wishLists?.value?.length;
    return (
        <Typography {...styles.listCountText}>
            {listCount} {listCount === 1 ? translate("list") : translate("lists")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MyListsCount),
    definition: {
        group: "My Lists" as any,
        allowedContexts: ["MyListsPage"],
        displayName: "List Count",
    },
};

export default widgetModule;
